import { render, staticRenderFns } from "./book-report.vue?vue&type=template&id=c9567c48&scoped=true"
import script from "./book-report.vue?vue&type=script&lang=js"
export * from "./book-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9567c48",
  null
  
)

export default component.exports